import { AfterViewInit, Component, Input, OnChanges, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';

import { HourMs, SecondMs } from 'rev-shared/date/Time.Constant';
import { IVideo } from 'rev-shared/media/IVideo';

import { IPulseTimelineEntry } from './IPulseTimelineEntry';

import { PulseTimelineEntryType } from './PulseTimelineEntryType';
import { VideoPulseService } from './VideoPulse.Service';

@Component({
	selector: 'pulse-timeline',
	templateUrl: './PulseTimeline.Component.html'
})
export class PulseTimelineComponent implements AfterViewInit, OnChanges {
	@Input() public video: IVideo;
	@Input() public currentTimeSec: number;
	@Input() public timelineEntries: IPulseTimelineEntry[];
	@Input() public vgApi: VideogularComponent;

	public editEntry: IPulseTimelineEntry;
	public deleteEntry: IPulseTimelineEntry;
	public activeEntry: IPulseTimelineEntry;
	public activeIndex: number;

	@ViewChild(CdkVirtualScrollViewport) public scrollViewport: CdkVirtualScrollViewport;

	constructor(
		public readonly VideoPulse: VideoPulseService
	) { }

	public ngAfterViewInit(): void {
		const fixSize = () => this.scrollViewport?.checkViewportSize();
		setTimeout(() => {
			fixSize();
			setTimeout(fixSize, 1000); //1st call doesnt always work
		}, 100);
	}

	public ngOnChanges(): void {
		this.updateActiveEntry();
	}

	private updateActiveEntry(): IPulseTimelineEntry {
		if(this.currentTimeSec > this.activeEntry?.startSecs &&
			this.currentTimeSec < this.findNextTranscriptTimelineEntry(this.activeIndex)?.startSecs) {
			return;
		}

		const i = this.timelineEntries?.findIndex((e, i) =>
			e.type === PulseTimelineEntryType.TRANSCRIPTION &&
			e.startSecs <= this.currentTimeSec &&
			this.currentTimeSec < this.findNextTranscriptTimelineEntry(i)?.startSecs);

		if(i >= 0 && i !== this.activeIndex) {
			this.activeEntry = this.timelineEntries[i];
			this.activeIndex = i;

			this.scrollViewport?.scrollToIndex(i);
		}
	}


	private get durationMs(): number {
		if (this.vgApi) {
			return this.vgApi.totalTime;
		}

		const transcriptLength: number = this.timelineEntries && this.timelineEntries.length;
		if (transcriptLength) {
			return this.timelineEntries[transcriptLength - 1].endSecs * SecondMs;
		}

		return 0;
	}

	public get isShowHours(): boolean {
		return this.durationMs >= HourMs;
	}

	private findNextTranscriptTimelineEntry(timelineEntryIndex: number): IPulseTimelineEntry {
		const numTimelineEntries = this.timelineEntries?.length;

		for (let index = timelineEntryIndex + 1; index < numTimelineEntries; ++index) {
			if (this.timelineEntries[index].type === PulseTimelineEntryType.TRANSCRIPTION) {
				return this.timelineEntries[index];
			}
		}
	}

	public onSelect(entry: IPulseTimelineEntry): void {
		this.vgApi.seekTime(entry.startSecs);
	}

	public onEdit(entry: IPulseTimelineEntry, oldEntry: IPulseTimelineEntry): void {
		this.editEntry = null;
		this.VideoPulse.editSubtitle(this.video, entry, oldEntry);
	}
}
